export const isNewProduct = (date) => {
  const createdDate = new Date(date);
  const currentDate = new Date();
  currentDate.setMonth(currentDate.getMonth() - 1);
  return createdDate > currentDate;
};
